import { render, staticRenderFns } from "./changePassword.vue?vue&type=template&id=0251fade&scoped=true&"
import script from "./changePassword.js?vue&type=script&lang=js&"
export * from "./changePassword.js?vue&type=script&lang=js&"
import style0 from "./changePassword.vue?vue&type=style&index=0&id=0251fade&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0251fade",
  null
  
)

export default component.exports